import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"FooterAlt" */ './FooterAlt').then((mod) => mod.default));
